export default __webpack_public_path__ + "static/media/anish.8ae7d6cb.txt";